import React, { memo } from 'react';

import { TThemeType } from '_style/style';

import { StyledSvgWrapper } from './style';
import Cross from './svg/cross.svg?react';
import Send from './svg/send.svg?react';

const glyphs = {
  cross: Cross,
  send: Send,
};

export type TGlyph = keyof typeof glyphs;

interface Props {
  color?: keyof TThemeType['color'];
  glyph: TGlyph;
  size?: number;
}

const Icon = memo(({ color, glyph, size }: Props) => {
  const Glyph = glyphs[glyph];

  return (
    <StyledSvgWrapper $color={color} $size={size}>
      <Glyph />
    </StyledSvgWrapper>
  );
});

export default Icon;
